<template>
  <a-modal
    :visible="visible"
    title="添加失败的邮箱地址"
    :closable="true"
    :centered="true"
    :mask-closable="false"
    :width="672"
    :footer="false"
    wrap-class-name="edm-filter-fail-modal"
    @cancel="handleCancel"
  >
    <p class="prompt">
      成功添加<b>{{ importContactResult.successNum }}</b>条联系人，有<b>{{ importContactResult.failNum }}</b>条联系人由于邮箱地址重复或者格式错误添加失败。
    </p>
    <div
      v-if="importContactResult && importContactResult.failArr"
      class="content"
    >
      <p
        v-for="(item, index) in importContactResult.failArr"
        :key="index"
        style="line-height: 30px;"
      >
        {{ item }}
      </p>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('edm/editContactList', ['importContactResult'])
  },

  methods: {
    handleCancel () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
/* .import-contact-fail-modal {
  position: fixed;
  top: 0;
  left: 50%;
  width: 1040px;
  margin-left: -520px;
  &.ant-alert-with-description.ant-alert-no-icon {
    padding: 5px;
  }
  .ant-alert-description {
    width: 100%;
  }
  .close {
    float: right;
    margin-right: 16px;
    color: #666;
  }
} */
.edm-filter-fail-modal {
  .ant-modal-body {
    padding: 0 0 24px;
  }
  .prompt {
    height:40px;
    line-height: 40px;
    margin-bottom: 24px;
    padding: 0 24px;
    background:#fdf1e1;
    b {
      font-weight: bold;
    }
  }
  .content {
    max-height: 200px;
    overflow: auto;
    margin: 20px;
    padding: 10px;
    border: solid 1px #dbdbdb;
     border-radius: 4px;
  }
}
</style>
